import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEditorRef, useEventPlateId } from '@udecode/plate-common';

import { ToolbarButton } from './ToolbarButton';

export const HistoryButtons = ({ ...props }) => {
  const editor = useEditorRef(useEventPlateId());

  return (
    <>
      <ToolbarButton
        name="Undo"
        icon={<FontAwesomeIcon icon={['fa', 'undo']} />}
        onClick={() => editor.undo()}
        {...props}
      />
      <ToolbarButton
        name="Redo"
        icon={<FontAwesomeIcon icon={['fa', 'redo']} />}
        onClick={() => editor.redo()}
        {...props}
      />
    </>
  );
};
